import Vue from "vue";

/**
 * Formats a phone number.
 * Example: 1123-456-7890 => 1(123) 456-7890
 *
 * @param {String} phone
 * @return {Void}
 */
Vue.filter('phone', function (phone) {
    if(phone.length == 11){
        return phone.replace(/[^0-9]/g, '').replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, '$1($2) $3-$4');
    }else{
        return phone.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '1($1) $2-$3');
    }
});


// WEBPACK FOOTER //
// ./src/filters.js